export default (() => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const EmailSettingsContainer = require('EmailDragDropEditorUI/containers/settings/EmailSettingsContainer');
  return EmailSettingsContainer.default || EmailSettingsContainer;
});